// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { TelegramQueryDocument, type TelegramQuery, type TelegramQueryVariables } from './TelegramQuery';

export async function getTelegramQueryClient(variables: TelegramQueryVariables) {
  return fetchGraphqlClient<TelegramQuery, TelegramQueryVariables>(TelegramQueryDocument, "TelegramQuery", { variables });
}
export const useTelegramQuery = (...args: QueryArgs<TelegramQueryVariables>) => useQuery<TelegramQuery, TelegramQueryVariables>(getTelegramQueryClient, ...args);